module.exports = __webpack_public_path__ + "static/media/IconoCompetenciasEspecificas.dcc0b819.svg";